import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../webcomponents.constants';
import { PoliciesSelectorNirvanaDataProvider } from '../dataProvider/PoliciesSelectorNirvanaDataProvider';

export class PoliciesSelectorDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, PoliciesSelectorNirvanaDataProvider);
  }
}
